import { MuiThemeProvider, Tab, Tabs, Typography } from '@material-ui/core';
import { customizerTheme } from 'assets/theme';
import { SvgIcon } from 'components/Shared/SvgIcon';
import { WithStyles } from 'decorators/withStyles';
import { enPreviewMode } from 'interfaces/previewMode';
import { IThemeCustomizerModel } from 'interfaces/theme';
import { PureComponent } from 'react';
import * as React from 'react';
import rxjsOperators from 'rxjs-operators';
import themeCustomizerService from 'services/themeCustomizer';
import { CDN_URL } from 'settings';

import ImagePicker from './ImagePicker';
import VideoPicker from './VideoPicker';

interface IProps {
  classes?: any;
}

interface IState {
  model: IThemeCustomizerModel;
  tab: number;
  imagePreviewMode: enPreviewMode;
}

@WithStyles(theme => ({
  addButton: {
    backgroundColor: theme.variables.colors['title'],
    color: '#FFF',
    textTransform: 'none',
    fontSize: 16,
    fontWeight: 'bold',
    margin: '8px 0',
    '&:hover': {
      backgroundColor: theme.variables.colors['customizerTitle']
    }
  },
  removeButton: {
    color: '#DC3F53',
    textTransform: 'none',
    fontSize: 16,
    fontWeight: 'bold',
    margin: '8px 0',
    border: '2px solid #DC3F53',
    padding: '6px 20px',
    '&:hover': {
      backgroundColor: 'transparent',
      color: '#c33345',
      borderColor: '#c33345'
    }
  },
  imageTitle: {
    fontSize: 16,
    marginTop: 4
  },
  buttons: {
    display: 'flex',
    justifyContent: 'space-between'
  }
}))
export default class PrincipalMedia extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      model: null,
      tab: 0,
      imagePreviewMode: enPreviewMode.DESKTOP
    };
  }

  componentDidMount() {
    themeCustomizerService
      .getData()
      .pipe(rxjsOperators.logError(), rxjsOperators.bindComponent(this))
      .subscribe(model => {
        this.setState({ model });
      });
  }

  onChangeFooterFontColor = (color: string) => {
    themeCustomizerService.setData({
      footer: {
        ...this.state.model.footer,
        font: {
          ...this.state.model.footer.font,
          color
        }
      }
    });
  };

  onChangeVideo = (video: string) => {
    themeCustomizerService.setData({ bannerYoutube: video });
  };

  onChangeImage = (image: string) => {
    if (this.state.imagePreviewMode === enPreviewMode.DESKTOP) {
      themeCustomizerService.setData({ bannerCenter: image });
    }

    if (this.state.imagePreviewMode === enPreviewMode.MOBILE) {
      themeCustomizerService.setData({ bannerCenterMobile: image });
    }
  };

  onChangeTab = (event: any, value: number) => {
    this.setState({ tab: value });
  };

  onChangePreviewMode = (imagePreviewMode: enPreviewMode) => {
    this.setState(oldState => {
      return { ...oldState, imagePreviewMode };
    });
  };

  showImage = (image: string) => {
    if (!image) {
      return '';
    }
    return image.startsWith('/') ? `${CDN_URL}${image}` : `${image}`;
  };

  render() {
    const { model, tab, imagePreviewMode } = this.state;
    const { classes } = this.props;

    const recomendations = {
      desktop: {
        width: 750,
        height: 500
      },
      mobile: {
        width: 600,
        height: 500
      }
    };

    if (!model) {
      return null;
    }

    return (
      <MuiThemeProvider theme={customizerTheme}>
        <div>
          <Tabs value={tab} onChange={this.onChangeTab} fullWidth indicatorColor="secondary" textColor="secondary">
            <Tab icon={<SvgIcon name="image" />} label="Imagem" />
            <Tab icon={<SvgIcon name="video" />} label="Vídeo" />
          </Tabs>

          {tab === 0 && (
            <div>
              {/* <PreviewMode onChangePreviewMode={this.onChangePreviewMode} /> */}
              <Typography variant="subtitle1" className={classes.imageTitle} gutterBottom>
                {imagePreviewMode === enPreviewMode.DESKTOP ? 'Imagem Desktop' : 'Imagem Mobile'}
              </Typography>

              {imagePreviewMode === enPreviewMode.DESKTOP ? (
                <ImagePicker
                  recomendations={recomendations.desktop}
                  onChangeImage={this.onChangeImage}
                  image={this.showImage(model.bannerCenter)}
                  previewDimensions={{ width: '100%', height: '150px' }}
                />
              ) : (
                <ImagePicker
                  recomendations={recomendations.mobile}
                  onChangeImage={this.onChangeImage}
                  image={this.showImage(model.bannerCenterMobile)}
                />
              )}
            </div>
          )}

          {tab === 1 && <VideoPicker video={model.bannerYoutube} onChangeVideo={this.onChangeVideo} />}
        </div>

        {/* <ColorPicker
          value={model.footer.font.color}
          label='Cor da Letra do Rodapé'
          handleChangeColor={this.onChangeFooterFontColor}
        />*/}
      </MuiThemeProvider>
    );
  }
}
